import { stockPlans } from "@/api/stockPlan/useStockPlanQuery";
import { LeftSpace } from "@/features/location/detail/LocationDetailForm";
import { useModal } from "@/features/modal/ModalStackManager";
import { DetailContainer } from "@/features/standard/detail/Container";
import { DetailContent } from "@/features/standard/detail/Content";
import { DetailWrapper } from "@/features/standard/detail/Wrapper";
import { Main } from "@/features/standard/Main";
import { Button, Flex, Tabs } from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { StockPlanWmsLogTab } from "../tab/StockPlanWmsLogTab";
import { StockPlanStatusForm } from "./StatusForm";
import { StockPlanDetailInForm } from "./StockPlanDetailInForm";

interface StockPlanDetailFormProps {
  stockPlanId: number | undefined;
}

const Detail = Object.assign(Main, {
  Container: DetailContainer,
  Wrapper: DetailWrapper,
  Content: DetailContent,
});

export const StockPlanDetailForm = (params: StockPlanDetailFormProps) => {
  const { stockPlanId } = params;
  const { t } = useTranslation();
  const { openModal } = useModal();
  const { data } = useQuery(
    stockPlans.detail({
      stockPlanId: stockPlanId ?? 0,
      populate: [
        "transportation",
        "itemName",
        "location",
        "partner",
        "wmsLogs",
        "lot",
        "user",
        "quantities",
      ],
    }),
  );

  return (
    <Detail.Container>
      <Detail.Wrapper>
        <Flex justify={"flex-start"} mb={"sm"}>
          <Button
            color="orange"
            leftIcon={<IconRefresh />}
            onClick={() => {
              openModal(
                <StockPlanStatusForm formatterProps={data?.data} />,
                null,
                t("common.change", { item: t("stockPlan.status") }),
              );
            }}
          >
            {t("common.change", { item: t("stockPlan.status") })}
          </Button>
        </Flex>
        <Detail.Content>
          <StockPlanDetailInForm data={data?.data} />
          <Tabs defaultValue="wmsLogs">
            <LeftSpace />
            <Tabs.List>
              <Tabs.Tab value="wmsLogs">{t("stockPlan.actualList")}</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="wmsLogs" p={20}>
              <StockPlanWmsLogTab wmsLog={data?.data?.wmsLogs ?? []} />
            </Tabs.Panel>
          </Tabs>
        </Detail.Content>
      </Detail.Wrapper>
    </Detail.Container>
  );
};
